import axios from 'axios';
import { Campaign } from '../types/campaign';

const API_URL = (import.meta as any).env.VITE_API_URL || 'http://localhost:8000';

export interface CampaignCreate {
  title: string;
  description: string;
  website_url: string;
  image_url?: string;
  category: string;
  keywords?: string;
  budget: number;
}

export interface CampaignUpdate extends Partial<CampaignCreate> {
  status?: string;
}

const getAuthHeaders = (token: string) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

const campaignService = {
  async getCampaigns(token: string): Promise<Campaign[]> {
    const response = await axios.get<Campaign[]>(`${API_URL}/campaigns/`, getAuthHeaders(token));
    return response.data;
  },

  async getCampaign(token: string, id: number): Promise<Campaign> {
    const response = await axios.get<Campaign>(`${API_URL}/campaigns/${id}`, getAuthHeaders(token));
    return response.data;
  },

  async createCampaign(token: string, data: CampaignCreate): Promise<Campaign> {
    const response = await axios.post<Campaign>(`${API_URL}/campaigns/`, data, getAuthHeaders(token));
    return response.data;
  },

  async updateCampaign(token: string, id: number, data: CampaignUpdate): Promise<Campaign> {
    const response = await axios.put<Campaign>(`${API_URL}/campaigns/${id}`, data, getAuthHeaders(token));
    return response.data;
  },

  async deleteCampaign(token: string, id: number): Promise<void> {
    await axios.delete(`${API_URL}/campaigns/${id}`, getAuthHeaders(token));
  },

  async pauseCampaign(token: string, id: number): Promise<void> {
    const response = await axios.post<Campaign>(`${API_URL}/campaigns/${id}/pause`, {}, getAuthHeaders(token));
    if (!response.data) {
      throw new Error('Failed to pause campaign');
    }
  },

  async resumeCampaign(token: string, id: number): Promise<void> {
    const response = await axios.post<Campaign>(`${API_URL}/campaigns/${id}/resume`, {}, getAuthHeaders(token));
    if (!response.data) {
      throw new Error('Failed to resume campaign');
    }
  },
};

export { campaignService }; 